function Noscript() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A "noscript" element is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Content within <code>&lt;noscript&gt;</code> is presented if JavaScript is disabled. Because nearly all users (including users of screen readers and other assistive technologies) have JavaScript enabled, <code>&lt;noscript&gt;</code> cannot be used to provide an accessible version of inaccessible scripted content.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that scripted content is accessible. The <code>&lt;noscript&gt;</code> content will be presented to very few users, but must be accessible if used.</p>
    </blockquote>
  )
}

export default Noscript